import 'angular-ui-bootstrap';
// import 'angular-ui-router';

//New Imports from the controllers.
import MaintenanceBoardController from './board.controller';
import MaintenancePerformPopupController from './complete/complete.controller';

const boardModule = angular.module('app.maintenance.board', ['ui.bootstrap', 'ui.router', 'gettext']);

boardModule
	//Controllers
	.controller('MaintenanceBoardController', MaintenanceBoardController)
	.controller('MaintenancePerformPopupController', MaintenancePerformPopupController);

export default boardModule.name;
